import React from "react";

const Empleado = ({ empleados, setIdEmp }) => {
  return (
    <div>
      <label className="block text-sm font-medium text-grisMira">
        Empleado responsable
      </label>      
      <select id="empleados" className="rounded-md " onChange={(e)=>setIdEmp(e.target.value)}>
        {empleados.map(element => (
          <option value={element.IdEmp}>{element.Empleado}</option>
        ))}
      </select>
    </div>
  );
};

export default Empleado;
